// 10級パッケージの8級
type ckptTypeForGrade_12_20kyu =
  | '頭から足までまっすぐ'
  | 'ベースポジション'
  | 'あしを体の前で入れかえる';

export const ckptForGrade_12_20kyu: ckptTypeForGrade_12_20kyu[] = [
  '頭から足までまっすぐ',
  'ベースポジション',
  'あしを体の前で入れかえる',
];

export const requirement_12_20kyu: ckptTypeForGrade_12_20kyu[] = [
  '頭から足までまっすぐ',
  'ベースポジション',
  'あしを体の前で入れかえる',
];

export type ckptDetails_12_20 =
  | '前後傾'
  | '腰が落ちていない'
  | '上げた足をキープできている'
  | '足の上がり'
  | '足をからだの前でいれかえる'
  //採点用
  | 'うで振り'
  | 'リーチアウト'
  | '後ろに蹴っていない';

type allCheckpoints_12_20kyu_type = {
  [key in ckptTypeForGrade_12_20kyu]: ckptDetails_12_20[];
};

export const allCheckPoints_12_20kyu: allCheckpoints_12_20kyu_type = {
  頭から足までまっすぐ: ['前後傾', '腰が落ちていない'],
  ベースポジション: ['足の上がり', '上げた足をキープできている'],
  あしを体の前で入れかえる: ['足をからだの前でいれかえる'],
};

export const borderLine_12_20kyu: allCheckpoints_12_20kyu_type = {
  頭から足までまっすぐ: ['前後傾'],
  ベースポジション: ['足の上がり'],
  あしを体の前で入れかえる: ['足をからだの前でいれかえる'],
};
